import React, { useState, useEffect } from 'react';

import { UserService } from '../../services/UserService';
import { FolderService } from '../../services/FolderService';
import { FactureService } from '../../services/FactureService';
import { ProformaService } from '../../services/ProformaService';
import { AbonnementService } from '../../services/AbonnementService';
import ColManager from '../../components/table/dynamic-table/col-manager/ColManager';
import { GlobalContext, GlobalDispatchContext } from "../../services/GlobalProvider";
import { useNavigate } from "react-router";
import { Navbar, Container, Nav, NavDropdown, Dropdown, Button, Row, Col, Form, Table, InputGroup, FormControl, OverlayTrigger, Tooltip, DropdownButton } from 'react-bootstrap';
import axios from 'axios';
import ErrorManager from "../../components/error-manager/ErrorManager";
import logo from '../../assets/img/logo/logo-xl.png'


import './Accueil.scss';


export default function Accueil() {

  const { userDetails, folderDetails, parametres, folders, setFolderDetails, preferences, globalContextLoaded, globalContextErrorList } = React.useContext(GlobalContext);
  const [folderInfos, setFolderInfos] = useState({
    nom: ""
  })
  const [parametresInfos, setParametresInfos] = useState({
    raison_sociale: "",
    enseigne: "",
    identification: ""
  })

  const navigate = useNavigate();

  useEffect(() => {
    setFolderInfos({
      nom: folderDetails?.dossier?.nom || ""
    })
  }, [folderDetails]);

  useEffect(() => {
    setParametresInfos({
      raison_sociale: parametres?.general?.raison_sociale || "",
      enseigne: parametres?.general?.enseigne || "",
      identification: parametres?.general?.identification || ""
    })
  }, [parametres]);

  /*   evtSource.onmessage = (event) => {
  
      console.log('-----event')
      console.log(event)
  
      setMessage(event.data)
    } */

  /* 
  ---> APPEL OK : 
  evtSource.addEventListener("time", (event) => {
      console.log(event);
      setMessage(event.data)
    }); */

  //content-type=text/event-stream;charset=UTF-8


  /*   const eventSource = new EventSource(resoureUrl, {
      headers: {
          'Authorization': 'Bearer ' + authorizationToken
      }
    }); */


  /*   const axiosAPI = axios.create({
      baseURL: global.config._API_DOMAIN_,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }) */


  /*   useEffect(() => {
  
      axios.get(`https://api.xlprog.nc/admin/testsse/`)
      .then(res => {
        console.log(res)
      })
    
      
    }, []); */


  /* ------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------ */
  /* ------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------ */

  /*   const token = localStorage.getItem('access_token');
  
    const evtSource = new EventSource(`${global.config._API_DOMAIN_}/admin/sse?key=${token}`, {
      //withCredentials: true,
      //authorizationHeader: "Bearer " + token,
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'text/event-stream',
        'charset': 'charset=UTF-8'
      }
    } ); */

  /* const [message, setMessage] = useState("XX") */


  return (

    <div id="Accueil" className="w-100 h-100 d-flex align-items-center justify-content-center pb-5 bg-gray-100">
      <img src={logo} alt="Logo XL Prog" />
      <div>
        <div className="bg-gray-200 p-4 rounded mt-4 ms-5  w-100">
          {folderInfos?.nom &&
            <div className="d-flex align-items-center mb-2">
              <i class="material-icons me-2 i-lg float-start">
                folder
              </i>
              <h6 className="m-0">
                {folderInfos?.nom}
              </h6>
            </div>
          }
          {parametresInfos?.raison_sociale &&
            <p className="m-0">{parametresInfos?.raison_sociale}</p>
          }
          {parametresInfos?.enseigne &&
            <p className="m-0">{parametresInfos?.enseigne}</p>
          }
          {parametresInfos?.identification &&
            <p className="m-0">Identification : {parametresInfos?.identification}</p>
          }

          {/* {parametresInfos?.adresse?.rue &&
          <p>Adresse : {parametresInfos?.adresse?.rue} {parametresInfos?.adresse?.code_postal} {parametresInfos?.adresse?.ville} {parametresInfos?.adresse?.pays}</p>
          } */}
        </div>

        {(globalContextErrorList.length > 0) &&
          <div className="mt-4 ms-5  w-100">
            <p className="mb-2 text-danger">Erreur lors de l'initialisation du dossier :</p>
            {globalContextErrorList.map((error, i) => (
              <ErrorManager key={i} error={error} />
            ))}
          </div>
        }
      </div>
    </div>

  );
}
